import { QuestionAddressBlock } from 'components/Questionnaires/blocks';

export function mailingAddressBlock() {
  return {
    id: 'mailingAddress',
    title: 'questionnaire.mailingAddress',
    component: QuestionAddressBlock,
    componentProps: {
      line1Label: 'questionnaire.mailingAddress.1.label',
      optional: true
    },
    info: {
      instructions: 'questionnaire.mailingAddress.1.info'
    },
    visible: true,
    linkBlock: true,
    lockGroup: 'mailingAddress',
  };
}

export default mailingAddressBlock;
